import FixedLightBox from '../../../../components/FixedLightBox'
import View from '../../../../View'
import SwitchToFreeLightBoxHeader from './SwitchToFreeLightBoxHeader'
import SwitchToFreeLightBoxContent from './SwitchToFreeLightBoxContent'
import SwitchToFreeLightBoxFooter from './SwitchToFreeLightBoxFooter'
import {connect} from '../../../../redux/utils'
import {getStartDate} from '../chooser/selectors'
import {getCurrentUsedUser, getDocumentsBaseUrl, getMaxFreeUsers, getUnavailableInFreeFeatures} from '../../selectors'
import {
    getContext,
    getDocumentUrls,
    getHostingZone,
    getPurchaseStepNumber,
    getPurchaseSteps,
    isContextChanged,
    isHostingZoneChanged
} from '../purchaseLightBox/selectors'
import {closePurchasePopup, switchToFreeVersion} from '../purchaseLightBox/actions'
import {bindActionCreators} from 'redux'

class SwitchToFreeLightBox extends View {
    constructor({
        switchToFreeVersion = () => {},
        closePurchasePopup = () => {},
    }) {
        super()

        this.actions = {
            switchToFreeVersion,
            closePurchasePopup,
        }

        this.state = {
            purchaseStepNumber: 0,
            steps: [],

            maxFreeUsers: 0,
            startDate: '',
            currentUsedUser: 0,
            unavailableInFreeFeatures: [],
            documentsBaseUrl: '',
            documentUrls: {
                serviceAgreementUrl: null,
                dataProcessingAgreementUrl: null,
                serviceAgreementExhibitUrl: null,
                invoiceUrl: null,
            },
            hostingZone: '',
            isHostingZoneChanged: false,
            context: '',
            isContextChanged: false,
        }

        this.onAnyStatePropertyChanged(['purchaseStepNumber', 'steps'], () => {
            const step = this.state.steps[this.state.purchaseStepNumber - 1]
            this.header.setState({purchaseStep: step})
            this.footer.setState({purchaseStep: step})
            this.content.setState({purchaseStep: step})
        })

        this.onStatePropertyChanged('startDate', (startDate) => this.header.setState({startDate}))
        this.onStateChanged(() => this.content.setState(this.state))

        this.onStatePropertyChanged('documentUrls', (documentUrls) => this.footer.setState({documentUrls}))
    }

    afterRender() {
        this.header = new SwitchToFreeLightBoxHeader()
        this.footer = new SwitchToFreeLightBoxFooter({
            onCancelButtonClick: () => this.lightBox.cancel(),
            onOkButtonClick: this.actions.switchToFreeVersion,
        })
        this.content = new SwitchToFreeLightBoxContent()

        this.lightBox = new FixedLightBox().init({
            id: 'switchToFreeLightBox',
            header: this.header,
            content: this.content,
            footer: this.footer,
            classNames: 'switchToFreeLightBox',
        })
        this.lightBox.setCancelCallback(() => {
            this.lightBox.hide()
            this.actions.closePurchasePopup()
        })
    }

    show() {
        this.lightBox.show()
    }
}

export default connect(
    (state) => ({
        purchaseStepNumber: getPurchaseStepNumber(state),
        steps: getPurchaseSteps(state),

        maxFreeUsers: getMaxFreeUsers(state),
        startDate: getStartDate(state),
        currentUsedUser: getCurrentUsedUser(state),
        unavailableInFreeFeatures: getUnavailableInFreeFeatures(state),
        documentsBaseUrl: getDocumentsBaseUrl(state),
        documentUrls: getDocumentUrls(state),
        hostingZone: getHostingZone(state),
        isHostingZoneChanged: isHostingZoneChanged(state),
        context: getContext(state),
        isContextChanged: isContextChanged(state),
    }),
    (dispatch) => ({
        switchToFreeVersion: bindActionCreators(switchToFreeVersion, dispatch),
        closePurchasePopup: bindActionCreators(closePurchasePopup, dispatch),
    })
)(SwitchToFreeLightBox)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/switchToFreeLightBox/SwitchToFreeLightBox.js